import { useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectIsNewLoyalty,
  selectPerksConfig,
  selectStatus,
  StatusPerk,
} from '../state';
import { groupPerksByType } from '../state/perksConfig/perksConfig.utils';

type UseStatusPerksResponse = {
  hasPriorityChat?: boolean;
  shopPromotionValue?: StatusPerk['value'];
  levelUpMultiplier?: StatusPerk['value'];
};

const useStatusPerks = (): UseStatusPerksResponse => {
  const isNewLoyalty = useSelector(selectIsNewLoyalty);
  const status = useSelector(selectStatus);
  const config = useSelector(selectPerksConfig);

  return useMemo(() => {
    if (!status || !isNewLoyalty) {
      return {};
    }

    const { perks } = config[status.playerStatus];
    const perksByType = groupPerksByType(perks);

    return {
      hasPriorityChat: Boolean(perksByType['PriorityCustomerSupport']),
      shopPromotionValue: perksByType['ShopWeeklyPromotion']?.value,
      levelUpMultiplier: perksByType['MultiplierOnLevelUp']?.value,
    };
  }, [status, config, isNewLoyalty]);
};

export default useStatusPerks;
